import { Matrix } from "@visactor/vutils";

import { BrowserContext2d } from "../browser";

export class NodeContext2d extends BrowserContext2d {
    constructor(canvas, dpr) {
        super(canvas, dpr);
        const context = canvas.nativeCanvas.getContext("2d");
        if (!context) throw new Error("发生错误，获取2d上下文失败");
        this.nativeContext = context, this.canvas = canvas, this.matrix = new Matrix(1, 0, 0, 1, 0, 0), 
        this.stack = [], this.dpr = null != dpr ? dpr : 1;
    }
    release(...params) {}
}

NodeContext2d.env = "node";
//# sourceMappingURL=context.js.map
